import { Button, Card, CardContent, CardHeader, CardTitle } from '@zond/ui';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { getAppFullName, getAppName, getLogo } from '../../../utils/get-logo';
import { useVerifyEmail } from './auth.queries';

export default function VerifyEmailPage() {
  const { t } = useTranslation('auth');
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [verificationStatus, setVerificationStatus] = useState<'pending' | 'success' | 'error'>('pending');
  const { mutate: verifyEmail } = useVerifyEmail();

  useEffect(() => {
    const token = searchParams.get('token');
    if (token) {
      verifyEmail(token, {
        onSuccess: () => setVerificationStatus('success'),
        onError: () => setVerificationStatus('error'),
      });
    } else {
      setVerificationStatus('error');
    }
  }, [verifyEmail, searchParams]);

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6 md:p-10">
      <div className="flex w-full max-w-sm flex-col gap-6">
        <div className="flex items-center gap-2 self-center font-medium">
          <img src={getLogo()} alt={t('logoAlt')} className="h-6 w-6" />
          {getAppFullName()}
        </div>
        <Card className="w-full">
          <CardHeader className="text-center">
            <CardTitle className="text-xl">{t('verifyEmail.title', { appName: getAppName() })}</CardTitle>
          </CardHeader>
          <CardContent className="text-center">
            <p className="mb-6">
              {verificationStatus === 'pending' && t('verifyEmail.pending')}
              {verificationStatus === 'success' && t('verifyEmail.success')}
              {verificationStatus === 'error' && t('verifyEmail.error')}
            </p>
            {verificationStatus === 'success' && (
              <Button className="w-full" onClick={() => navigate('/login')}>
                {t('verifyEmail.proceed')}
              </Button>
            )}
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
